import React, { Component } from "react";
import Button from 'module-common/Button'
import { CaseManagementStore, ShowNotice } from 'Store'
import ModalWithFields from 'module-common/ModalWithField'
import { graphql, compose } from "react-apollo";
import { observer } from "mobx-react";
import {
  queryGetCustomerFromCase,
  mutationAddTicketToCase,
  queryGetTicketFromCase,
  queryGetBrandOfTicketing,
  queryGetProductOfTicketing
} from "Apollo";
import styled from "styled-components";
import Linkify from "react-linkify";

const FieldSet = [
    {
        name: 'brand',
        displayName: 'Brand',
        type: 'dropdown',
        value: [],
        isRequired: true
    },
    {
        name: 'product',
        displayName: 'Product',
        type: 'dropdown',
        value: [],
        isRequired: true
    },
    {
        name: 'subject',
        displayName: 'Title',
        isRequired: true
    },
    {
        name: 'summary',
        displayName: 'Content', 
        type: 'textarea',
        isRequired: true
    },
    {
        name: 'channel',
        displayName: 'Channel',
        isRequired: true
    },
    {
        name: 'customer_name',
        displayName: 'Customer Name',
        isRequired: true
    },
    {
        name: 'contact_number',
        displayName: 'Phone Number'
    },
    {
        name: 'email',
        displayName: 'Email'
    },
    {
        name: 'address',
        displayName: 'Address',
        type: 'textarea'
    }            
]



export default compose(
    graphql(queryGetCustomerFromCase, { name: 'customer'}),
    graphql(queryGetTicketFromCase, { name: 'ticket'}),
    graphql(mutationAddTicketToCase, { name: 'addTicket'}),
    graphql(queryGetBrandOfTicketing, { name: 'brand'}),
    graphql(queryGetProductOfTicketing, { name: 'product'}),
)(observer(
    class TicketPanel extends Component {

        state = { isModalOpen: false }

        prepareFieldSet = () => {
            
            const { 
                customer: { getCustomerFromCase },
                brand: { getBrandOfTicketing },
                product: { getProductOfTicketing }
            } = this.props
            if(!getCustomerFromCase || !getBrandOfTicketing || !getProductOfTicketing) return FieldSet
            const { fields, channelHandler } = getCustomerFromCase
            const finalFields = FieldSet.map((field) => {
                const { name } = field
                let value = ''
                if (name == 'channel') {
                    value = channelHandler.channel.name
                } else if (name == 'customer_name') {
                    value = channelHandler.displayName
                } else if (name == 'email') {
                    const found = fields.find(item => item.fieldType.name.toLowerCase() == 'email')
                    if(found) value = found.value
                } else if (name == 'contact_number') {
                    const found = fields.find(item => item.fieldType.name.toLowerCase() == 'phone number')
                    if(found) value = found.value
                } else if (name == 'address') {
                    const found = fields.find(item => item.fieldType.name.toLowerCase() == 'address')
                    if(found) value = found.value
                } else if (name == 'brand') {
                    value = getBrandOfTicketing.map(item => ({...item, label: item.displayName}))
                } else if (name == 'product') {
                    value = getProductOfTicketing.map(item => ({...item, label: item.name}))
                }

                return {...field, value }
            })
            return finalFields
        }

        isString = (x) => {
            return Object.prototype.toString.call(x) === "[object String]"
        }

        sanitize = (str) => {
            if(!str || !this.isString(str)) return str
            else return str.trim() 
        }    


        addTicket = async (data) => {
            const selectedCase = CaseManagementStore.selectedCase
            const variables = {
                case: { id: selectedCase.id },
                email: this.sanitize(data.email.value),
                phoneNumber: this.sanitize(data.contact_number.value),
                address: this.sanitize(data.address.value),
                title: this.sanitize(data.subject.value),
                content: this.sanitize(data.summary.value),
                brand: data.brand.selected.id,
                product: data.product.selected.id
            }
            try {
                await this.props.addTicket({ 
                    variables,
                    refetchQueries: ['getTicketFromCase']
                })
                ShowNotice("profile-update-success")
                this.setState({...this.state, isModalOpen: false })
            } catch(e) {
                ShowNotice("profile-update-error");
            }
            
        }
    
    
        render() {
            const { ticket: { getTicketByCase }, editable  } = this.props
            const selectedCase = CaseManagementStore.selectedCase
            const state = this.state
            return (
                <div>
                    <TicketFormWithQuery 
                        case={{ id: selectedCase.id }} 
                        show={state.isModalOpen}  
                        onCancel={() => this.setState({...state, isModalOpen: false}) }
                        onConfirm={data => this.addTicket(data)}
                    />
                    {!getTicketByCase && <Button
                        color="transparent"
                        size="x-small"
                        border
                        onClick={() => this.setState({...state, isModalOpen: true})}
                        disabled={!editable}
                    >
                        + CREATE TICKET
                    </Button>}
                    {getTicketByCase && <Ticket {...getTicketByCase} />}
                </div>
            )
        }
    }    
))

const TicketFormWithQuery = compose(
    graphql(queryGetCustomerFromCase, { name: 'customer' , options: { fetchPolicy: 'network-only' }}),
    graphql(queryGetBrandOfTicketing, { name: 'brand', options: { fetchPolicy: 'network-only' }}),
    graphql(queryGetProductOfTicketing, { name: 'product', options: { fetchPolicy: 'network-only' }}),
)(observer(
    class TicketForm extends Component {

        prepareFieldSet = () => {
            
            const { 
                customer: { getCustomerFromCase },
                brand: { getBrandOfTicketing },
                product: { getProductOfTicketing }
            } = this.props
            if(!getCustomerFromCase || !getBrandOfTicketing || !getProductOfTicketing) return FieldSet
            const { fields, channelHandler } = getCustomerFromCase
            const finalFields = FieldSet.map((field) => {
                const { name } = field
                let value = ''
                if (name == 'channel') {
                    value = channelHandler.channel.name
                } else if (name == 'customer_name') {
                    value = channelHandler.displayName
                } else if (name == 'email') {
                    const found = fields.find(item => item.fieldType.name.toLowerCase() == 'email')
                    if(found) value = found.value
                } else if (name == 'contact_number') {
                    const found = fields.find(item => item.fieldType.name.toLowerCase() == 'phone number')
                    if(found) value = found.value
                } else if (name == 'address') {
                    const found = fields.find(item => item.fieldType.name.toLowerCase() == 'address')
                    if(found) value = found.value
                } else if (name == 'brand') {
                    value = getBrandOfTicketing.map(item => ({...item, label: item.displayName}))
                } else if (name == 'product') {
                    value = getProductOfTicketing.map(item => ({...item, label: item.name}))
                }

                return {...field, value }
            })
            return finalFields
        }

        isString = (x) => {
            return Object.prototype.toString.call(x) === "[object String]"
        }

        sanitize = (str) => {
            if(!str || !this.isString(str)) return str
            else return str.trim() 
        }    

        render() {
            const { show, onConfirm, onCancel } = this.props
            console.log(this.props)
            return show && (<ModalWithFields
                fields={this.prepareFieldSet()}    
                title="Create Ticket"
                onCancel={() => {
                    if(onCancel) onCancel()
                }}
                onConfirm={(data) => {
                    if(onConfirm) onConfirm(data)
                }}
            />)            
        }
    }
))

class Ticket extends Component {

    renderList = () => {
        const { 
            ticketId,
            address,
            phoneNumber,
            email,
            title,
            content,
            ticketCode,
            status
        } = this.props
        const fields = [
            { name: 'Title', value: title },
            { name: 'Content', value: content },
            { name: 'Ticket Link', value: <Linkify properties={{target: '_blank'}} >{`http://ticket.care.nolimit.id/tickets/view/${ticketId}`}</Linkify> },
            { name: 'Track Code', value: ticketCode },
            { name: 'Address', value: address }, 
            { name: 'Phone Number', value: phoneNumber },
            { name: 'Email', value: email },
            { name: 'Status', value: status },
        ]
        return fields.map(({ name, value}) => {
            return (<Wrapper key={name}>
                <Name>{name}</Name>
                <Colon>:</Colon>
                <Value>{value}</Value>    
            </Wrapper>)
        })
    }

    render() {
        return (<div>
            {this.renderList()}
        </div>)
    }

}

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  align-items: center;
  margin-bottom: 10px;
`;

const Colon = styled.div`
  margin-left: auto;
  margin-right: 4px;
`;

const Value = styled.div`
  width: 100%;
  padding: 4px 4px;
  border: none;
  border: 1px solid ${props => props.theme.panelBorder};
  border-radius: 3px;
`;

const Name = styled.div`
  width: 60px;
  flex: none;
`;




// WEBPACK FOOTER //
// ./src/module-case-management/info-panel/ticketing/TicketPanel.js